import * as React from "react";
import LeaderBoardMenu from "@/components/molecules/leader-board/leader-board-menu";
import LeaderBoardTable from "@/components/molecules/leader-board/leader-board-table";
import { LeaderboardMetric, MenuType } from "@/types/leader-board";
import { useLeaderboardData } from "@/hooks/useLeaderboardData";
import LeaderboardSkeleton from "@/components/atomics/leaderboard-skeleton";
import { useWallet } from "@/context/WalletContext";

interface LeaderBoardProps {
  selectedMenu: MenuType;
  onMenuChange: (menu: MenuType) => void;
  metric: LeaderboardMetric;
  onMetricChange: (metric: LeaderboardMetric) => void;
}

export default function LeaderBoard({
  selectedMenu,
  onMenuChange,
  metric,
  onMetricChange,
}: LeaderBoardProps) {
  const { isConnected, walletAddress } = useWallet();
  const { data, myData, isLoading, error, refetch, loadMore, hasMore } =
    useLeaderboardData({
      selectedMenu,
      metric,
      limit: 10,
      isConnected,
      walletAddress,
    });

  // Show skeleton only on initial load (when no data and loading)
  const isInitialLoad = isLoading && data.length === 0;

  if (isInitialLoad) {
    return (
      <div>
        <h1 className="text-[44px] text-center">LEADERBOARD</h1>
        <LeaderBoardMenu
          selectedMenu={selectedMenu}
          onMenuChange={onMenuChange}
          metric={metric}
          onMetricChange={onMetricChange}
        />
        <LeaderboardSkeleton selectedMenu={selectedMenu} />
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h1 className="text-[44px] text-center">LEADERBOARD</h1>
        <LeaderBoardMenu
          selectedMenu={selectedMenu}
          onMenuChange={onMenuChange}
          metric={metric}
          onMetricChange={onMetricChange}
        />
        <div className="text-primary-red text-center mt-4">Error: {error}</div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-[44px] text-center">LEADERBOARD</h1>
      <LeaderBoardMenu
        selectedMenu={selectedMenu}
        onMenuChange={onMenuChange}
        metric={metric}
        onMetricChange={onMetricChange}
      />
      <LeaderBoardTable
        data={data}
        myData={isConnected ? myData || null : null}
        metric={metric}
        selectedMenu={selectedMenu}
        onRefetchData={refetch}
        onLoadMore={loadMore}
        hasMore={hasMore}
        isLoading={isLoading}
      />
    </div>
  );
}
